import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { GoPackage } from 'react-icons/go'
import { FaPencilAlt, FaTrash } from 'react-icons/fa'

import Pagination from '../utils/Pagination'
import { useStateContext } from '../../state/context'
import { setCurrentDrug } from '../../state/actions/actions'
import { setCurrentProvision } from '../../state/actions/pharmacist.actions'


const PharmacistProvisionsTable = ({ data, showList, setShowList, title }) => {
    const dispatch = useDispatch()

    const { modals, setModals, appState, setAppState } = useStateContext()

    const [currentData, setCurrentData] = useState([])

    return (
        <div className="flex justify-between items-center w-full">
            <div
                className="flex flex-col w-full cursor-pointer"
            >
                <div className="py-2">
                    <div
                        className="flex justify-start items-center space-x-4 bg-gray-200 border-2 border-gray-200 p-1"
                        onClick={() => setShowList(!showList)}
                    >
                        <h4 className="text-dark-blue text-[14px] font-bold">
                            {title}
                        </h4>
                        <GoPackage className="text-dark-blue" size={20} />
                    </div>
                    {showList && (
                        <table className="border w-full cursor-default">
                            <thead className="">
                                <tr>
                                    <th
                                        scope="col"
                                        className="text-sm font-medium text-gray-900 pr-[2em] px-4 py-4 text-left"
                                    >
                                        S/N
                                    </th>
                                    <th
                                        scope="col"
                                        className="text-sm font-medium text-gray-900 pr-[2em] py-4 text-left"
                                    >
                                        Name
                                    </th>
                                    <th
                                        scope="col"
                                        className="text-sm font-medium text-gray-900 pr-[1em] py-4 text-left"
                                    >
                                        Price
                                    </th>
                                    <th
                                        scope="col"
                                        className="text-sm font-medium text-gray-900 pr-[2em] py-4 text-left"
                                    >
                                        Image
                                    </th>
                                    <th
                                        scope="col"
                                        className="text-sm font-medium text-gray-900 pr-[5em] py-4 text-left"
                                    >
                                        Manage
                                    </th>
                                    <th
                                        scope="col"
                                        className="text-sm font-medium text-gray-900 py-4 text-left"
                                    >

                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentData?.map((item, index) => (
                                    <tr key={`${item.id}`}>
                                        <td className="px-4 py-2 whitespace-nowrap text-sm font-medium text-gray-900">
                                            {index + 1}
                                        </td>
                                        <td className="text-sm text-gray-900 font-light py-2 whitespace-nowrap">
                                            {item.title}
                                        </td>
                                        <td className="text-sm text-gray-900 font-light py-2 whitespace-nowrap">
                                            {item.price}
                                        </td>
                                        <td className="text-sm text-gray-900 font-light py-2 whitespace-nowrap w-[150px] pr-4">
                                            <img src={`http://localhost:8000${item.image}`} className='w-[50px] h-[50px]' alt="" />
                                        </td>
                                        <td className="text-sm text-gray-900 font-light py-2 whitespace-nowrap">
                                            {/* {item.is_available ? 'Available' : 'Out of Stock'} */}

                                            <button
                                                type="button"
                                                className="inline-block px-6 py-2 bg-purple-500 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:shadow-lg hover:translate-x-1 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-dark-green active:shadow-lg transition duration-500 ease-in-out"
                                                onClick={() => {
                                                    dispatch(setCurrentDrug({ data: item }))
                                                    // dispatch(getDrugBinCards({ id: item.pkid }))
                                                    setAppState({ ...appState, showDrugInventory: !appState.showDrugInventory })
                                                }}
                                            >
                                                Inventory
                                            </button>
                                        </td>

                                        <td className=" flex text-2xl space-x-4 text-gray-900 font-semibold py-2 whitespace-nowrap">
                                            {/* <AiFillEye
                                                size={25}
                                                className='text-gray-600 cursor-pointer'
                                                onClick={() => {
                                                    dispatch(setCurrentProvision({ data: item }))
                                                    setModals({ ...modals, showPharmacistViewProvisionModal: !modals.showPharmacistViewProvisionModal })
                                                }}
                                            /> */}
                                            <FaPencilAlt
                                                size={20}
                                                className='text-green-600 cursor-pointer'
                                                onClick={() => {
                                                    dispatch(setCurrentProvision({ data: item }))
                                                    setModals({ ...modals, showPharmacistUpdateProvisionModal: !modals.showPharmacistUpdateProvisionModal })
                                                }}
                                            />
                                            <FaTrash
                                                size={20}
                                                className="text-orange-400 cursor-pointer"
                                                onClick={() => {
                                                    dispatch(setCurrentProvision({ data: item }))
                                                    setModals({ ...modals, showPharmacistDeleteProvisionModal: !modals.showPharmacistDeleteProvisionModal })
                                                }}
                                            />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}

                    <Pagination
                        data={data}
                        currentData={currentData}
                        setCurrentData={setCurrentData}
                    />
                </div>
            </div>
        </div >
    )
}

export default PharmacistProvisionsTable